import React from "react";
import Container from "react-bootstrap/Container";

function Impressum() {
  return (
    <div className="hero-container">
      <Container
        className="py-5"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "10px",
          color: "black",
        }}
      >
        <h1 className="text-center mb-4">Impressum</h1>

        <h3>Angaben gemäß § 5 TMG</h3>
        <p>
          Grüne Wege GmbH<br />
          Musterstraße 123<br />
          12345 Musterstadt<br />
        </p>

        <h3>Vertreten durch:</h3>
        <p>
          Max Mustermann (Geschäftsführer)<br />
          Kontaktperson: Max Mustermann<br />
        </p>

        <h3>Kontakt:</h3>
        <p>
          Telefon: +49 123 456 789<br />
          E-Mail: impressum@gruenewege.de<br />
        </p>

        <h3>Registereintrag:</h3>
        <p>
          Eintragung im Handelsregister<br />
          Registergericht: Amtsgericht Musterstadt<br />
          Handelsregisternummer: HRB 123456
        </p>

        <h3>Umsatzsteuer-Identifikationsnummer:</h3>
        <p>
          Umsatzsteuer-ID: DE123456789
        </p>

        <h3>Haftungsausschluss (Disclaimer)</h3>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die
          Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir
          jedoch keine Haftung.
        </p>

        <h3>Verbraucherschlichtung:</h3>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h3>Urheberrecht:</h3>
        <p>
          Alle auf dieser Website verwendeten Inhalte, insbesondere Texte,
          Bilder, Grafiken und Logos, sind urheberrechtlich geschützt und dürfen
          ohne ausdrückliche Zustimmung des Rechteinhabers nicht verwendet werden.
        </p>

        <p>
          Dieses Impressum gilt auch für die Social Media Profile von Grüne Wege
          GmbH.
        </p>
      </Container>
    </div>
  );
}

export default Impressum;